import { render, staticRenderFns } from "./left-center.vue?vue&type=template&id=a9567f22&scoped=true&"
import script from "./left-center.vue?vue&type=script&lang=js&"
export * from "./left-center.vue?vue&type=script&lang=js&"
import style0 from "./left-center.vue?vue&type=style&index=0&id=a9567f22&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9567f22",
  null
  
)

export default component.exports